export default __webpack_public_path__ + "static/media/emo_judge_inactive.bd9ce410.svg";